import { updates } from '@/mocks/homepage';

export default function UpdatesSection() {
  return (
    <section id="updates" className="relative py-16 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">最新动态</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            平台动态、新剧上线、功能更新一手掌握
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div key={item.id} className="relative flex gap-4 md:gap-6">
              <div className="flex flex-col items-center">
                <div className={`w-3 h-3 rounded-full border-2 flex-shrink-0 mt-1.5 ${
                  idx === 0 ? 'bg-accent-500 border-accent-500' : 'bg-background-100 border-background-300'
                }`}></div>
                {idx < updates.length - 1 && (
                  <div className="w-px flex-1 bg-background-300/40 my-1.5"></div>
                )}
              </div>
              <div className={`pb-8 ${idx === updates.length - 1 ? 'pb-0' : ''}`}>
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className="text-xs text-foreground-500 font-mono">{item.date}</span>
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                    item.label === '剧集上线' ? 'bg-primary-500/15 text-primary-400 border border-primary-500/20' :
                    item.label === '新剧预告' ? 'bg-accent-500/15 text-accent-400 border border-accent-500/20' :
                    item.label === '平台公告' ? 'bg-secondary-500/15 text-secondary-400 border border-secondary-500/20' :
                    'bg-background-200/50 text-foreground-500 border border-background-300/30'
                  }`}>
                    {item.label}
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-bold text-foreground-950 font-heading mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}